import { getCustomerOrdersApiRequest, getCustomerReservations } from './customer';
import { getCustomerSubscriptions } from './subscriptions';
import { handleError, handleSuccess, triggerGet, triggerPost, triggerPut } from './utils';
const getUsersApiRequest = async () => {
  const apiResponse = await triggerGet('/business/users');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  if (responseData.report.status === 404) {
    return handleSuccess({
      data: [],
      report: {}
    });
  }
  return handleError(responseData);
};
const getUsersStaffApiRequest = async id => {
  const apiResponse = await triggerGet("/business/staff/".concat(id));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData, true, {
      options: responseData.options
    });
  }
  return handleError(responseData);
};
const editStaffProvidersApiRequest = async (id, data) => {
  const apiResponse = await triggerPut("/business/staff/".concat(id), data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const updateUserStatusApi = async id => {
  const apiResponse = await triggerGet("/business/users/status/".concat(id));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData, true, {
      options: responseData.options
    });
  }
  return handleError(responseData);
};
const inviteUserApiRequest = async data => {
  const apiResponse = await triggerPost("/business/users", data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData, true, {
      options: responseData.options
    });
  }
  return handleError(responseData);
};
const getUserApi = async () => {
  const apiResponse = await triggerGet("/user/account");
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData, true, {
      options: responseData.options
    });
  }
  return handleError(responseData);
};
const getAllReservationsApiRequest = async () => {
  const checkIfSuccess = obj => obj.success || obj.status === 404;
  const [reservations, orders, subscriptions] = await Promise.all([getCustomerReservations(), getCustomerOrdersApiRequest(), getCustomerSubscriptions()]);
  if (checkIfSuccess(reservations) && checkIfSuccess(orders) && checkIfSuccess(subscriptions)) {
    const data = {
      reservations: reservations.data || [],
      orders: orders.data || [],
      subscriptions: subscriptions.data || []
    };
    return {
      success: true,
      data
    };
  }
  return handleError({
    success: false
  });
};
export { getUserApi, getUsersApiRequest, updateUserStatusApi, getUsersStaffApiRequest, editStaffProvidersApiRequest, inviteUserApiRequest, getAllReservationsApiRequest };